<div *ngIf="!this.ready" id="scormLoader" fxLayout="column" fxLayoutAlign="space-evenly center" fxLayoutGap="20px">
  <app-loading-page></app-loading-page>
</div>

<div class="scormWrapper">
  <iframe #iframe (load)="onLoad(iframe)" *ngIf="this.metadataReady" [src]="this.safeURL" id="scormFrame" name="scormFrame"
    frameborder="0"></iframe>
  <app-browser-note *ngIf="this.ready" class="mb-20"></app-browser-note>
</div>